import { render, staticRenderFns } from "./edit-qn.vue?vue&type=template&id=981a2cb6&"
import script from "./edit-qn.vue?vue&type=script&lang=js&"
export * from "./edit-qn.vue?vue&type=script&lang=js&"
import style0 from "./edit-qn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports